import type { WeekIndicatorsValues } from 'core/api/home/weekly/useApiGetWeekIndicators'
import { daysArray } from './daily-board-utils'
import DailyDataUnavailable from './daily-data-unavailable'
import { useFormatNumber } from 'core/hooks/useFormatNumber'

interface DailyBoardProgressionsProps {
  weeklyData: Record<number, WeekIndicatorsValues>
  isCurrentWeek: boolean
}

const DailyBoardProgressions = ({ weeklyData, isCurrentWeek }: DailyBoardProgressionsProps) => {
  const formatNumber = useFormatNumber()
  const today = new Date().getDay() + 1

  return (
    <>
      {daysArray.map(day => {
        const progression = weeklyData?.[day]?.progression
        if (weeklyData == null || progression?.in_error) {
          return (
            <div key={day} className="vp-body-s mg-daily-board-item">
              <DailyDataUnavailable />
            </div>
          )
        }
        return (
          <div
            key={day}
            data-testid={`progression-cell-${day}`}
            className={
              'vp-caption' +
              (isCurrentWeek && today === day ? ' mg-daily-board-item-today' : ' mg-daily-board-item') +
              (progression?.value == null
                ? ''
                : ' mg-daily-board-progression-' + (progression?.value < 0 ? 'negative' : 'positive'))
            }
          >
            {formatNumber(progression?.value, '-', {
              style: 'percent',
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
              signDisplay: 'always'
            })}
          </div>
        )
      })}
    </>
  )
}

export default DailyBoardProgressions
